import styled from "@emotion/styled";

import { fontMerriweather, fontRobotoCondensed, theme } from "shared/lib/styles";

import { BaseImage } from "scmp-app/components/common/base-image";
import { EntityLink } from "scmp-app/components/entity-link";

export const Container = styled(EntityLink)`
  display: flex;
  flex-flow: column nowrap;
  gap: 12px;

  inline-size: 100%;
  block-size: min-content;
`;

export const ImageContainer = styled.div`
  position: relative;
`;

export const Image = styled(BaseImage)`
  inline-size: 100%;
  block-size: auto;

  border-radius: 12px;

  object-fit: contain;
`;

export const DurationBadge = styled.div`
  position: absolute;
  inset-block-end: 0;
  inset-inline-start: 0;

  block-size: 24px;
  padding: 4px;

  color: #2c4692;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;

  border-start-end-radius: 4px;

  background: #ffffff;
`;

export const Header = styled.div`
  display: block;

  block-size: 42px;

  color: #000000;
  font-weight: 700;
  font-size: 15px;
  font-family: ${fontMerriweather};
  font-style: normal;
  line-height: 140%;
  text-overflow: ellipsis;

  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  overflow: hidden;

  ${theme.breakpoints.up("tablet")} {
    block-size: 63px;
    -webkit-line-clamp: 3;
  }
`;
